import { createFileRoute } from '@tanstack/react-router';
import { lazyRouteComponent } from '@tanstack/react-router';

// Lazy load the dashboard view for code splitting
const DashboardView = lazyRouteComponent(() => import('../../../features/dashboard/dashboard-view'), 'DashboardView');

export const Route = createFileRoute('/_auth/dashboard/')({
  component: DashboardView,
});
